import { Notify } from 'quasar';
import { Store as $store } from '@store';
import { useRouter } from 'vue-router';

export const checkUserHasTemporaryPassword = () => {
  const isLoggedIn = $store.getters['app/isLoggedIn'];
  const hasTempPassword = $store.getters['app/userHasTemporaryPassword'];

  if (!isLoggedIn || !hasTempPassword) {
    return;
  }

  const $router = useRouter();

  Notify.create({
    color: 'negative',
    icon: 'key',
    title: 'Please update your password',
    message: 'You are using a temporary password.',
    timeout: 0,
    multiLine: true,
    position: 'top',
    actions: [
      {
        label: 'Update Password',
        color: 'yellow',
        handler: () => $router.push({ name: 'profile' }),
      },
    ],
  });
};
